import React, { Suspense, useEffect } from 'react';
import { Switch } from 'react-router-dom';
import bookingProcess, { useCompanyDetails } from '@platform/booking-process';
import {
  ThemeProvider, defaultTheme, updateThemeByCustomColors, useSelector, useDispatch,
} from '@platform/rcl';
import PublicRoute from './components/PublicRoute';
import { fetchLanguageStrings } from './actions/i18n';

export function App () {
  const languageLoading = useSelector((state) => state.i18n.loading);
  const dispatch = useDispatch();

  const { accountIsLoading, accountData } = useCompanyDetails();

  // Get language strings on load
  useEffect(() => {
    dispatch(fetchLanguageStrings());
  }, []);

  if (languageLoading || accountIsLoading) {
    return null;
  }

  const theme = updateThemeByCustomColors(defaultTheme, accountData?.data?.brand_colours);
  return (
    <ThemeProvider theme={theme}>
      <div>
        <Suspense fallback={<div>loading</div>}>
          <Switch>
            { bookingProcess({ publicRoute: PublicRoute }) }
          </Switch>
        </Suspense>
      </div>
    </ThemeProvider>
  );
}

export default App;
